import React from 'react';
import PropTypes from 'prop-types';
import { ZCDTable } from '@zencity/common-ui';
import classNames from 'classnames';

function StatisticsTable(props) {
  const { statistics } = props;
  const { mean, comparisonValue } = statistics;
  const hasComparison = typeof comparisonValue === 'number';

  const columnArray = [
    { Header: 'Minimum', accessor: 'min', width: false },
    { Header: 'Maximum', accessor: 'max', width: false },
    { Header: 'Median', accessor: 'median', width: false },
    { Header: 'Mean', accessor: 'mean', width: false },
    ...(hasComparison ? [{ Header: 'Comparison', accessor: 'comparisonValue', width: false }] : []),
    { Header: 'Mode', accessor: 'mode', width: false },
    { Header: 'Std. Deviation', accessor: 'stdDev', width: false },
  ];

  const renderMean = () => {
    if (!hasComparison) return mean;
    const change = (mean / comparisonValue - 1) * 100;

    return (
      <>
        {mean}
        <span
          className={classNames('engage-results-statistics-table__change', {
            'engage-results-statistics-table__change--positive': change > 0,
            'engage-results-statistics-table__change--negative': change < 0,
          })}
        >
          {`${change >= 0 ? '+' : ''}${change.toFixed(2)}%`}
        </span>
      </>
    );
  };

  const row = {
    ...statistics,
    mean: renderMean(),
  };

  return (
    <div className="engage-results-statistics-table">
      <ZCDTable columnArray={columnArray} tableData={[row]} />
    </div>
  );
}

StatisticsTable.propTypes = {
  statistics: PropTypes.shape({
    max: PropTypes.number.isRequired,
    mean: PropTypes.number.isRequired,
    median: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    comparisonValue: PropTypes.number,
    mode: PropTypes.number.isRequired,
    stdDev: PropTypes.number.isRequired,
  }).isRequired,
};

export default StatisticsTable;
